/**
 * operation接口配置
 */
import type { ApiEndpoint } from '../types';
import { API_CATEGORIES } from '../constants';

export const operationEndpoints: ApiEndpoint[] = [
  {
    id: "operation-list",
    method: "GET",
    path: "/api/operation/all",
    name: "获取授权操作列表",
    description: "分页查询授权操作列表，支持多条件搜索",
    category: API_CATEGORIES.OPERATION,
    queryParams: [
      { name: "current", type: "number", required: false, description: "当前页码", example: "1" },
      { name: "pageSize", type: "number", required: false, description: "每页条数", example: "10" },
      { name: "keyword", type: "string", required: false, description: "关键词搜索（名称、代码、描述）" },
      { name: "service_name", type: "string", required: false, description: "微服务名称" },
      { name: "page", type: "string", required: false, description: "页面名称" },
      { name: "action", type: "string", required: false, description: "操作名称" },
      { name: "status", type: "string", required: false, description: "状态（active-启用，inactive-禁用）" },
    ],
    responseFields: [
      { name: "success", type: "boolean", description: "请求是否成功" },
      { name: "message", type: "string", description: "响应消息" },
      { name: "data.items", type: "array", description: "操作列表" },
      { name: "data.total", type: "number", description: "总记录数" },
      { name: "data.pagination", type: "object", description: "分页信息" },
      { name: "data.items[].id", type: "string", description: "操作ID" },
      { name: "data.items[].name", type: "string", description: "操作名称" },
      { name: "data.items[].code", type: "string", description: "操作代码" },
      { name: "data.items[].description", type: "string", description: "操作描述" },
      { name: "data.items[].isActive", type: "boolean", description: "是否启用" },
      { name: "data.items[].isSystem", type: "boolean", description: "是否系统操作" },
      { name: "data.items[].service", type: "object", description: "所属微服务信息" },
    ],
    requiredPermission: "msadmin:operations:view",
  },
  {
    id: "operation-create",
    method: "POST",
    path: "/api/operation",
    name: "创建授权操作",
    description: "创建新的授权操作",
    category: API_CATEGORIES.OPERATION,
    bodyParams: [
      { name: "name", type: "string", required: true, description: "操作名称" },
      { name: "code", type: "string", required: true, description: "操作代码" },
      { name: "description", type: "string", required: false, description: "操作描述" },
      { name: "service_id", type: "string", required: true, description: "所属微服务ID" },
      { name: "is_active", type: "boolean", required: false, description: "是否启用" },
    ],
    responseFields: [
      { name: "success", type: "boolean", description: "请求是否成功" },
      { name: "message", type: "string", description: "响应消息" },
      { name: "data.id", type: "string", description: "新创建的操作ID" },
    ],
    requiredPermission: "msadmin:operations:create",
  },
  {
    id: "operation-update",
    method: "PUT",
    path: "/api/operation/:id",
    name: "更新授权操作",
    description: "更新授权操作信息",
    category: API_CATEGORIES.OPERATION,
    pathParams: [{ name: "id", type: "string", required: true, description: "操作ID" }],
    bodyParams: [
      { name: "name", type: "string", required: false, description: "操作名称" },
      { name: "code", type: "string", required: false, description: "操作代码" },
      { name: "description", type: "string", required: false, description: "操作描述" },
      { name: "is_active", type: "boolean", required: false, description: "是否启用" },
    ],
    responseFields: [
      { name: "success", type: "boolean", description: "请求是否成功" },
      { name: "message", type: "string", description: "响应消息" },
    ],
    requiredPermission: "msadmin:operations:update",
  },
  {
    id: "operation-delete",
    method: "DELETE",
    path: "/api/operation/:id",
    name: "删除授权操作",
    description: "根据ID删除授权操作",
    category: API_CATEGORIES.OPERATION,
    pathParams: [{ name: "id", type: "string", required: true, description: "操作ID" }],
    responseFields: [
      { name: "success", type: "boolean", description: "请求是否成功" },
      { name: "message", type: "string", description: "响应消息" },
    ],
    requiredPermission: "msadmin:operations:delete",
  },
  {
    id: "operation-batch-delete",
    method: "POST",
    path: "/api/operation/batch-delete",
    name: "批量删除授权操作",
    description: "根据ID列表批量删除授权操作",
    category: API_CATEGORIES.OPERATION,
    bodyParams: [{ name: "ids", type: "array", required: true, description: "操作ID数组", example: "[\"1\", \"2\", \"3\"]" }],
    responseFields: [
      { name: "success", type: "boolean", description: "请求是否成功" },
      { name: "message", type: "string", description: "响应消息" },
      { name: "data.deletedCount", type: "number", description: "删除的操作数量" },
    ],
    requiredPermission: "msadmin:operations:delete",
  },
  {
    id: "operation-update-status",
    method: "PUT",
    path: "/api/operation/:id/status",
    name: "更新授权操作状态",
    description: "启用或禁用授权操作",
    category: API_CATEGORIES.OPERATION,
    pathParams: [{ name: "id", type: "string", required: true, description: "操作ID" }],
    bodyParams: [{ name: "is_active", type: "boolean", required: true, description: "是否启用" }],
    responseFields: [
      { name: "success", type: "boolean", description: "请求是否成功" },
      { name: "message", type: "string", description: "响应消息" },
    ],
    requiredPermission: "msadmin:operations:update",
  },
];
